export default __webpack_public_path__ + "static/media/zdjecia.c62c2fec.PNG";